import React, { useEffect } from 'react';
import { useAuthRouting } from '../contexts/AuthRouteContext';
import { useNavigate } from 'react-router-dom';
import styles from './ProfilePage.module.css';

export default function ProfilePage() {
  const { requireAuth } = useAuthRouting();
  const navigate = useNavigate();

  useEffect(() => {
    requireAuth(() => {}, () => navigate('/login'));
  }, [requireAuth, navigate]);

  return (
    <div className={styles.profilePage}>
      <h2 className={styles.title}>Your Profile</h2>

      {/* <div className={styles.section}>
        <p><strong>Email:</strong> {user.email}</p>
      </div> */}

      <button
        className={styles.changePasswordButton}
        onClick={() => navigate('/change-password')}
      >
        Change Password
      </button>
    </div>
  );
}
